module.exports = __webpack_public_path__ + "static/media/team1.a7e6840d.webp";